import { navigate } from 'hookrouter'
import { useForm } from 'hooks/useForm'
import React, { FC } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { createProject } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { CompanyIdUrlParam } from 'types'
// import { ErrorsDisplay } from '../ErrorsDisplay'

interface InputProps {
  name: string
}

export const NewProjectForm: FC<CompanyIdUrlParam> = ({ companyId }) => {
  const [, dispatch] = useAppContext()

  const [{ name }, handleInputChange, handleSubmit, validated] = useForm<
    InputProps
  >(submittedInputs => {
    createProject(dispatch, companyId, submittedInputs)
    navigate(`/company/${companyId}`)
  })

  return (
    <>
      <Row>
        <Col>
          <h1>Create a New Project</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Project Name</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={name || ''}
                name="name"
                type="text"
                placeholder="Enter Project Name"
              />
            </Form.Group>
            <Button variant="primary" value="Upload new Project" type="submit">
              Create New Project
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )
}
